module.exports = __webpack_public_path__ + "static/media/473A95AF-D9DA-4B9D-8170-3E6B13FF1F18.2e8f56c9.jpeg";